module.exports = __webpack_public_path__ + "img/tucan-1.99400cf4.png";